<template>
  <div container>
    <div grid="row wrap" column="12">
      <div v-html="externalMembership_header_html"></div>
    </div>
    <div grid="row wrap" v-if="value.userMessage.length !==0 ">
      <ul>
        <li v-for="item in value.userMessage" >
          <p class="lips validation">{{ item}} </p>
        </li>
      </ul>
    </div>
    <div grid="row wrap">
      <div column="12">
        <br/>
        <app-checkbox-simple
          ref="ongoingMatchesInitial"
          :value="internalValue.ongoingMatchesInitial"
          @click="setOngoingMatchesInitial($event)"
          label='Ongoing Membership Matches Initial Membership?'
          valueKey='ongoingMatchesInitial'
        />
      </div>
      <br/>
      <br/>
      <div class="_mtxs" column="4">
        <app-select
          :errorMessage="ongFileFormatError"
          :invalid="$v.internalValue.ongFileFormat.$invalid"
          :options="ongoingMembershipFormatOptions"
          :required='false'
          label='Active Employee Membership Format:'
          v-model="$v.internalValue.ongFileFormat.$model"
          valueKey='ongFileFormat'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="4">
        <app-select
          :errorMessage="ongFileSenderError"
          :invalid="$v.internalValue.ongFileSender.$invalid"
          :options="fileSenderOptions"
          :required='false'
          @change='ongMembershipSourceChanged'
          label='Active Employee Membership Source:'
          v-model="$v.internalValue.ongFileSender.$model"
          valueKey='ongFileSender'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="4">
        <app-input
          :disabled='ongoingTPACompanyDisabled'
          :hidden="ongoingTPACompanyDisabled"
          :errorMessage="ongTpaCompNameError"
          :invalid="$v.internalValue.ongTpaCompName.$invalid"
          :required='false'
          label='TPA Company Name:'
          v-model="$v.internalValue.ongTpaCompName.$model"
          valueKey='ongTpaCompName'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
    </div>
    <div grid="row wrap">
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="ongContactFnError"
          :invalid="$v.internalValue.ongContactFn.$invalid"
          :required='false'
          label='Contact First Name:'
          v-model="$v.internalValue.ongContactFn.$model"
          valueKey='ongContactFn'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="ongContactLnError"
          :invalid="$v.internalValue.ongContactLn.$invalid"
          :required='false'
          label='Contact Last Name:'
          v-model="$v.internalValue.ongContactLn.$model"
          valueKey='ongContactLn'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="ongContactEmailError"
          :invalid="$v.internalValue.ongContactEmail.$invalid"
          :required='false'
          label='Contact Email:'
          v-model="$v.internalValue.ongContactEmail.$model"
          valueKey='ongContactEmail'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
      <div class="_mtxs" column="3">
        <app-input
          :errorMessage="ongContactPhoneError"
          :invalid="$v.internalValue.ongContactPhone.$invalid"
          :required="false"
          label="Contact Phone:"
          v-model="$v.internalValue.ongContactPhone.$model"
          valueKey="ongContactPhone"
          maxlength="12"
          :pattern="[0-9]"
          @input="[formatOngContactPhone(),emitOngoingMembershipInformation()]"
        />
      </div>
    </div>
    <div grid="row wrap">
      <div class="_mtxs" column="6">
        <app-select
          :errorMessage="ongIncludeCobraError"
          :invalid="$v.internalValue.ongIncludeCobra.$invalid"
          :options="membershipCobraOptions"
          :required='false'
          @change='ongAddlDetailsChanged'
          label='Will Ongoing Membership Include COBRA?'
          v-model="$v.internalValue.ongIncludeCobra.$model"
          valueKey='ongIncludeCobra'
          @input="emitOngoingMembershipInformation()"
        />
      </div>
    </div>
    <div :hidden="ongoingCobraDisabled" id="cobraSection">
      <div grid="row wrap" column="12">
        <div v-html="externalMembership_cobra_header_html"></div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="4">
          <app-select
            :errorMessage="ongCobraFileFormatError"
            :invalid="$v.internalValue.ongCobraFileFormat.$invalid"
            :options="ongoingMembershipFormatOptions"
            :required='false'
            label='COBRA Employee Membership Format:'
            v-model="$v.internalValue.ongCobraFileFormat.$model"
            valueKey='ongCobraFileFormat'
            @input="emitOngoingMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-select
            :errorMessage="ongCobraFileSenderError"
            :invalid="$v.internalValue.ongCobraFileSender.$invalid"
            :options="fileSenderOptions"
            :required='false'
            @change='ongCobraMembershipSourceChanged'
            label='COBRA Employee Enrollment Source:'
            v-model="$v.internalValue.ongCobraFileSender.$model"
            valueKey='ongCobraFileSender'
            @input="emitOngoingMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-input
            :disabled='ongoingCobraTPACompanyDisabled'
            :hidden="ongoingCobraTPACompanyDisabled"
            :errorMessage="ongCobraTpaCompNameError"
            :invalid="$v.internalValue.ongCobraTpaCompName.$invalid"
            :required='false'
            label='TPA Company Name:'
            v-model="$v.internalValue.ongCobraTpaCompName.$model"
            valueKey='ongCobraTpaCompName'
            @input="emitOngoingMembershipInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="ongCobraContactFnError"
            :invalid="$v.internalValue.ongCobraContactFn.$invalid"
            :required='false'
            label='Contact First Name:'
            v-model="$v.internalValue.ongCobraContactFn.$model"
            valueKey='ongCobraContactFn'
            @input="emitOngoingMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="ongCobraContactLnError"
            :invalid="$v.internalValue.ongCobraContactLn.$invalid"
            :required='false'
            label='Contact Last Name:'
            v-model="$v.internalValue.ongCobraContactLn.$model"
            valueKey='ongCobraContactLn'
            @input="emitOngoingMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="ongCobraContactEmailError"
            :invalid="$v.internalValue.ongCobraContactEmail.$invalid"
            :required='false'
            label='Contact Email:'
            v-model="$v.internalValue.ongCobraContactEmail.$model"
            valueKey='ongCobraContactEmail'
            @input="emitOngoingMembershipInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="ongCobraContactPhoneError"
            :invalid="$v.internalValue.ongCobraContactPhone.$invalid"
            :required="false"
            label="Contact Phone:"
            v-model="$v.internalValue.ongCobraContactPhone.$model"
            valueKey="ongCobraContactPhone"
            maxlength="12"
            :pattern="[0-9]"
            @input="[formatOngCobraContactPhone(),emitOngoingMembershipInformation()]"
          />
        </div>
      </div>
    </div>
    <div grid="row wrap">
      <button
        @click="saveOngoingMembershipInformation()" class="btn --sm _mtxs"
        column="12"
        :disabled="$v.$invalid || hasTitleSectionError"
      >
        Continue
      </button>
    </div>
    <div>
      <hr class="_mbxs _mts">
    </div>
  </div>
</template>

<script>
  import AppInput from '@atoms/Input'
  import AppCheckboxSimple from '@atoms/CheckboxSimple'
  import AppSelect from '@atoms/Select'
  import SelectOptions from '@mixins/clientOnboardSelectOptions'
  import { email, maxLength, requiredIf } from 'vuelidate/lib/validators'
  import { formatPhone, twelveDigitsLong } from '@/utils'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'
  import { eventBus } from '@/main'

  export default {
    mixins: [
      SelectOptions,
      clientOnboardVerbiage
    ],
    components: {
      AppInput,
      AppCheckboxSimple,
      AppSelect
    },
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        isLastSigner: this.value.ongoingMembershipValues.isLastSigner,
        hasTitleSectionError: this.value.ongoingMembershipValues.hasTitleSectionError,
        internalValue: {
          ongoingMatchesInitial: this.value.ongoingMembershipValues.ongoingMatchesInitial || false,
          ongFileFormat: this.value.ongoingMembershipValues.ongFileFormat || '',
          ongFileSender: this.value.ongoingMembershipValues.ongFileSender || '',
          ongIncludeCobra: this.value.ongoingMembershipValues.ongIncludeCobra || '',
          ongTpaCompName: this.value.ongoingMembershipValues.ongTpaCompName || '',
          ongContactFn: this.value.ongoingMembershipValues.ongContactFn || '',
          ongContactLn: this.value.ongoingMembershipValues.ongContactLn || '',
          ongContactEmail: this.value.ongoingMembershipValues.ongContactEmail || '',
          ongContactPhone: this.value.ongoingMembershipValues.ongContactPhone || '',
          ongCobraFileFormat: this.value.ongoingMembershipValues.ongCobraFileFormat || '',
          ongCobraFileSender: this.value.ongoingMembershipValues.ongCobraFileSender || '',
          ongCobraTpaCompName: this.value.ongoingMembershipValues.ongCobraTpaCompName || '',
          ongCobraContactFn: this.value.ongoingMembershipValues.ongCobraContactFn || '',
          ongCobraContactLn: this.value.ongoingMembershipValues.ongCobraContactLn || '',
          ongCobraContactEmail: this.value.ongoingMembershipValues.ongCobraContactEmail || '',
          ongCobraContactPhone: this.value.ongoingMembershipValues.ongCobraContactPhone || ''
        },
        ongoingCobraDisabled: true,
        ongoingTPACompanyDisabled: true,
        ongoingCobraTPACompanyDisabled: true
      }
    },
    validations: {
      internalValue: {
        ongFileFormat: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        ongFileSender: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        ongIncludeCobra: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        ongTpaCompName: {
          required: requiredIf(function () {
            return !this.ongoingTPACompanyDisabled
          }),
          maxLength: maxLength(40)
        },
        ongContactFn: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        ongContactLn: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        ongContactEmail: {
          email,
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(77)
        },
        ongContactPhone: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          twelveDigitsLong
        },
        ongCobraFileFormat: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.ongoingCobraDisabled
          })
        },
        ongCobraFileSender: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.ongoingCobraDisabled
          })
        },
        ongCobraTpaCompName: {
          required: requiredIf(function () {
            return !this.ongoingCobraDisabled && !this.ongoingCobraTPACompanyDisabled
          }),
          maxLength: maxLength(40)
        },
        ongCobraContactFn: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.ongoingCobraDisabled
          }),
          maxLength: maxLength(27)
        },
        ongCobraContactLn: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.ongoingCobraDisabled
          }),
          maxLength: maxLength(27)
        },
        ongCobraContactEmail: {
          email,
          required: requiredIf(function () {
            return this.isLastSigner && !this.ongoingCobraDisabled
          }),
          maxLength: maxLength(77)
        },
        ongCobraContactPhone: {
          required: requiredIf(function () {
            return this.isLastSigner && !this.ongoingCobraDisabled
          }),
          twelveDigitsLong
        }
      }
    },
    computed: {
      ongFileFormatError() {
        if (!this.$v.internalValue.ongFileFormat.required) {
          return 'required'
        }
        return null
      },
      ongFileSenderError() {
        if (!this.$v.internalValue.ongFileSender.required) {
          return 'required'
        }
        return null
      },
      ongIncludeCobraError() {
        if (!this.$v.internalValue.ongIncludeCobra.required) {
          return 'required'
        }
        return null
      },
      ongTpaCompNameError() {
        if (!this.$v.internalValue.ongTpaCompName.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongTpaCompName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongContactFnError() {
        if (!this.$v.internalValue.ongContactFn.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongContactFn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongContactLnError() {
        if (!this.$v.internalValue.ongContactLn.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongContactLn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongContactEmailError() {
        if (!this.$v.internalValue.ongContactEmail.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongContactEmail.email) {
          return 'Not a valid email address'
        } else if (!this.$v.internalValue.ongContactEmail.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongContactPhoneError() {
        if (!this.$v.internalValue.ongContactPhone.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongContactPhone.twelveDigitsLong) {
          return '10 digits long'
        }
        return null
      },
      ongCobraFileFormatError() {
        if (!this.$v.internalValue.ongCobraFileFormat.required) {
          return 'required'
        }
        return null
      },
      ongCobraFileSenderError() {
        if (!this.$v.internalValue.ongCobraFileSender.required) {
          return 'required'
        }
        return null
      },
      ongCobraTpaCompNameError() {
        if (!this.$v.internalValue.ongCobraTpaCompName.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongCobraTpaCompName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongCobraContactFnError() {
        if (!this.$v.internalValue.ongCobraContactFn.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongCobraContactFn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongCobraContactLnError() {
        if (!this.$v.internalValue.ongCobraContactLn.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongCobraContactLn.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongCobraContactEmailError() {
        if (!this.$v.internalValue.ongCobraContactEmail.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongCobraContactEmail.email) {
          return 'Not a valid email address'
        } else if (!this.$v.internalValue.ongCobraContactEmail.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      ongCobraContactPhoneError() {
        if (!this.$v.internalValue.ongCobraContactPhone.required) {
          return 'required'
        } else if (!this.$v.internalValue.ongCobraContactPhone.twelveDigitsLong) {
          return '10 digits long'
        }
        return null
      }
    },
    methods: {
      setOngoingMatchesInitial(event) {
        this.presetInternalMemberShipValues(event)
        this.ongAddlDetailsChanged()
        this.ongMembershipSourceChanged()
        this.ongCobraMembershipSourceChanged()
        this.emitOngoingMembershipInformation()
      },
      checkIfInternalMemberShipValuesEmpty() {
        return (this.value.initialMembershipValues.initFileFormat === undefined || this.value.initialMembershipValues.initFileFormat === '') &&
          (this.value.initialMembershipValues.initFileSender === undefined || this.value.initialMembershipValues.initFileSender === '') &&
          (this.value.initialMembershipValues.initTpaCompName === undefined || this.value.initialMembershipValues.initTpaCompName === '') &&
          (this.value.initialMembershipValues.initContactFn === undefined || this.value.initialMembershipValues.initContactFn === '') &&
          (this.value.initialMembershipValues.initContactLn === undefined || this.value.initialMembershipValues.initContactLn === '') &&
          (this.value.initialMembershipValues.initContactEmail === undefined || this.value.initialMembershipValues.initContactEmail === '') &&
          (this.value.initialMembershipValues.initContactPhone === undefined || this.value.initialMembershipValues.initContactPhone === '') &&
          (this.value.initialMembershipValues.initIncludeCobra === undefined || this.value.initialMembershipValues.initIncludeCobra === null || this.value.initialMembershipValues.initIncludeCobra === '') &&
          (this.value.initialMembershipValues.initCobraFileFormat === undefined || this.value.initialMembershipValues.initCobraFileFormat === '') &&
          (this.value.initialMembershipValues.initCobraFileSender === undefined || this.value.initialMembershipValues.initCobraFileSender === '') &&
          (this.value.initialMembershipValues.initCobraTpaCompName === undefined || this.value.initialMembershipValues.initCobraTpaCompName === '') &&
          (this.value.initialMembershipValues.initCobraContactFn === undefined || this.value.initialMembershipValues.initCobraContactFn === '') &&
          (this.value.initialMembershipValues.initCobraContactLn === undefined || this.value.initialMembershipValues.initCobraContactLn === '') &&
          (this.value.initialMembershipValues.initCobraContactEmail === undefined || this.value.initialMembershipValues.initCobraContactEmail === '') &&
          (this.value.initialMembershipValues.initCobraContactPhone === undefined || this.value.initialMembershipValues.initCobraContactPhone === '')
      },
      presetInternalMemberShipValues(event) {
        if (event !== null) { // use the check box click value wen clicked otherwise procced with the current value
          this.internalValue.ongoingMatchesInitial = event.target.checked
        }
        if (this.internalValue.ongoingMatchesInitial) {
          if (this.checkIfInternalMemberShipValuesEmpty()) { // if initial values are empty,clear the values
            if (event !== null) {
              alert('Initial membership field(s) was not previously entered.')
              event.preventDefault()
            }
            this.internalValue.ongoingMatchesInitial = false
            // this.clearNonCobraValues();
          } else { // set initial values
            this.setInternalMemberShipValues()
          }
        } else if (event !== null) { // clear when check box set to false but not on page mount
          // this.clearNonCobraValues();
        }
      },
      setInternalMemberShipValues() {
        this.internalValue.ongFileFormat = this.value.initialMembershipValues.initFileFormat === 'OL' ? 'EX' : this.value.initialMembershipValues.initFileFormat
        this.internalValue.ongFileSender = this.value.initialMembershipValues.initFileSender
        this.internalValue.ongTpaCompName = this.value.initialMembershipValues.initTpaCompName
        this.internalValue.ongContactFn = this.value.initialMembershipValues.initContactFn
        this.internalValue.ongContactLn = this.value.initialMembershipValues.initContactLn
        this.internalValue.ongContactEmail = this.value.initialMembershipValues.initContactEmail
        this.internalValue.ongContactPhone = this.value.initialMembershipValues.initContactPhone
        this.internalValue.ongIncludeCobra = this.value.initialMembershipValues.initIncludeCobra
        this.internalValue.ongCobraFileFormat = this.value.initialMembershipValues.initCobraFileFormat === 'OL' ? 'EX' : this.value.initialMembershipValues.initCobraFileFormat
        this.internalValue.ongCobraFileSender = this.value.initialMembershipValues.initCobraFileSender
        this.internalValue.ongCobraTpaCompName = this.value.initialMembershipValues.initCobraTpaCompName
        this.internalValue.ongCobraContactFn = this.value.initialMembershipValues.initCobraContactFn
        this.internalValue.ongCobraContactLn = this.value.initialMembershipValues.initCobraContactLn
        this.internalValue.ongCobraContactEmail = this.value.initialMembershipValues.initCobraContactEmail
        this.internalValue.ongCobraContactPhone = this.value.initialMembershipValues.initCobraContactPhone
      },
      clearCobraValues() {
        this.internalValue.ongCobraFileFormat = ''
        this.internalValue.ongCobraFileSender = ''
        this.internalValue.ongCobraTpaCompName = ''
        this.internalValue.ongCobraContactFn = ''
        this.internalValue.ongCobraContactLn = ''
        this.internalValue.ongCobraContactEmail = ''
        this.internalValue.ongCobraContactPhone = ''
      },
      clearNonCobraValues() {
        this.internalValue.ongFileFormat = ''
        this.internalValue.ongFileSender = ''
        this.internalValue.ongTpaCompName = ''
        this.internalValue.ongContactFn = ''
        this.internalValue.ongContactLn = ''
        this.internalValue.ongContactEmail = ''
        this.internalValue.ongContactPhone = ''
        this.internalValue.ongIncludeCobra = ''
      },
      ongAddlDetailsChanged() {
        if (this.internalValue.ongIncludeCobra === '' || this.internalValue.ongIncludeCobra === null ||
          this.internalValue.ongIncludeCobra === 'O' || this.internalValue.ongIncludeCobra === 'Y') {
          this.ongoingCobraDisabled = true
          this.clearCobraValues()
        } else {
          this.ongoingCobraDisabled = false
        }
      },
      ongMembershipSourceChanged() {
        if (this.internalValue.ongFileSender === 'TPA') {
          this.ongoingTPACompanyDisabled = false
        } else {
          this.ongoingTPACompanyDisabled = true
          this.internalValue.ongTpaCompName = ''
        }
      },
      ongCobraMembershipSourceChanged() {
        if (this.internalValue.ongCobraFileSender === 'TPA') {
          this.ongoingCobraTPACompanyDisabled = false
        } else {
          this.ongoingCobraTPACompanyDisabled = true
          this.internalValue.ongCobraTpaCompName = ''
        }
      },
      formatOngContactPhone() {
        this.internalValue.ongContactPhone = formatPhone(this.internalValue.ongContactPhone)
      },
      formatOngCobraContactPhone() {
        this.internalValue.ongCobraContactPhone = formatPhone(this.internalValue.ongCobraContactPhone)
      },
      isFormValid() {
        this.$v.$touch()
        return !this.$v.$error
      },
      saveOngoingMembershipInformation() {
        if (this.isFormValid()) {
          this.$emit('continue', this.internalValue)
        }
      },
      emitOngoingMembershipInformation() {
        this.$emit('ongoingMemInfoUpdated', this.internalValue)
      }
    },
    mounted() {
      this.$refs.ongoingMatchesInitial.$el.children[1].focus()
      setTimeout(() => document.getElementById('ExternalMembershipTitle').scrollIntoView(), 100)
      // this.setOngoingMatchesInitial(null);
      this.ongAddlDetailsChanged()
      this.ongMembershipSourceChanged()
      this.ongCobraMembershipSourceChanged()
      this.emitOngoingMembershipInformation()
    },
    created() {
      eventBus.$on('groupTitleSectionHasError', (data) => {
        this.hasTitleSectionError = data
      })
    },
    watch: {
      internalValue: {
        deep: true,
        handler() {
          this.$emit('valueChanged', true)
        }
      }
    }
  }
</script>
